import React from 'react';
import PropType from 'prop-types';
import Close from '@tradera/blueprint/theme/icons2/close.svg?jsx';

const ModalHeader = ({ children, onClose, className = '' }) => (
    <div
        className={`tr-modal-header bg-light py-4 px-5 d-flex position-relative ${className}`}
        onClick={e => {
            onClose();
            e.stopPropagation();
        }}>
        <div className="h4 text-truncate text-center mb-0 w-100">
            {children}
        </div>
        <div
            className="cursor-pointer position-absolute py-4 px-5"
            style={{ right: 0, top: 0 }}>
            <Close className="icon icon-lg icon-dark" />
        </div>
    </div>
);

ModalHeader.propTypes = {
    children: PropType.node.isRequired,
    onClose: PropType.func,
    className: PropType.string
};

export default ModalHeader;
